var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatusPending = function SvgStatusPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M528 320c0 114.9-93.1 208-208 208s-208-93.1-208-208 93.1-208 208-208 208 93.1 208 208zm-464 0c0 141.4 114.6 256 256 256s256-114.6 256-256S461.4 64 320 64 64 178.6 64 320zm232-136v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7 7.4-11.1 4.4-25.9-6.7-33.3L344 307.2V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
  })));
};
export default SvgStatusPending;